<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <div v-if="detalle!==null">
      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          <p> <b>{{ nombre }}</b></p>
          <p> Matricula: <b>{{ mat }}</b></p>
          <p> Estado del alumno: <b>{{ detalle.descripcion }}</b></p>
          <p> Periodo con estado de baja: <b>{{ detalle.periodo_baja }}</b></p>
          <p> Estado del alumno antes de la baja: <b>{{ bajaAlumnoH.status_nombre }}</b></p>

        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <p> Plan: <b>{{ detalle.nombre }}</b> </p>
          <p> Número de agendas: <b>{{ detalle.numeroagendas }}</b></p>
          <p> Plazo Máximo del plan: <b>{{ detalle.plazoMax }} meses</b></p>
          <p> Generación: <b>{{ detalle.generacion }}</b></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <materias
            :ag="ag"
          />
        </b-col>
      </b-row>
      <b-form>
        <b-row
          class="my-1"
        >
          <b-col
            md="6"
          >
            <b-form-group
              v-if="aCupdatefile === true"
              :label="'Seleccione la carta para recursamiento '+((storedFiles.length > 0) ? ' Actualizada' : '')"
            >
              <b-form-file
                v-model="fileToUpload"
                placeholder="Escoge un archivo"
                :state="Boolean(fileToUpload)"
                accept=".pdf"
              >
                <template
                  slot="file-name"
                  slot-scope="{ names }"
                >
                  <b-badge variant="primary">
                    {{ names }}
                  </b-badge>
                  <b-badge
                    v-if="names.length > 1"
                    variant="dark"
                    class="ml-1"
                  >
                    + {{ names.length - 1 }} More files
                  </b-badge>
                </template>
              </b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              v-if="aCupdatefile === true"
              label="Razón de la Resolución *"
            >
              <b-form-textarea
                id="textarea-solicitud"
                v-model="textareaResolucion"
                placeholder="Escriba aquí por lo menos 10 caracteres"
                :state="textareaResolucion.length >= 10"
                rows="1"
                max-rows="1"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          class="my-1"
        >
          <b-col
            md="12"
          >

            <b-form-group label="Seleccione un periodo distinto al periodo de baja.">
              <selectPeriodoActual
                :per.sync="perobj"
                :esp="detalle.id_plan"
                :mat="mat"
                @tipoPeri="perobj=$event"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p
              v-if="bajaAlumnoH === null || (bajaAlumnoH.historico_status_agenda !== 7 && bajaAlumnoH.historico_status_agenda !== 4)"
              class="text-center"
            >
              <b>Contacte el área de sistemas</b>: <b class="text-primary">"el esado del alumno antes de la baja",</b><b> no permite su re inscripción</b>.
            </p>
            <div v-if="bajaAlumnoH !== null && (bajaAlumnoH.historico_status_agenda === 7 || bajaAlumnoH.historico_status_agenda === 4)">
              <p class="text-center">
                <b>Importante</b>,
                Una vez que haya creado la <b>orden de  pago</b>, <b class="text-primary">Gestione la orden para completar la re-incripcion del alumno</b>.
              </p>
              <b-button
                class="mr-2"
                variant="primary"
                @click.prevent="validationForm"
              >
                Crear orden de  pago
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>

    </div>
  </b-overlay>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import store from '@/store'
import {
  BForm, BFormGroup, BOverlay, BRow, BCol, BButton, BFormFile, BBadge, BFormTextarea,
} from 'bootstrap-vue'
import {
  onMounted, ref, getCurrentInstance, watch, computed,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import selectPeriodoActual from '@/views/components/selects/select-periodos-apartir-hoy.vue'
import { assignAsPersonalDocument } from '@/views/components/documentacion/useDocumentacion'
import { useBajasDetalle, bajaAlumno } from './useBaja'
import materias from './contenidoModalMaterias.vue'

export default {
  components: {
    BFormFile,
    BBadge,
    BForm,
    materias,
    BFormGroup,
    BOverlay,
    BRow,
    BCol,
    BButton,
    BFormTextarea,
    selectPeriodoActual,
  },
  props: {
    alubaja: {
      type: [Number, null],
      default: null,
    },
    ag: {
      type: [Number, null],
      default: null,
    },
    mat: {
      type: [Number, null],
      default: null,
    },
    nombre: {
      type: [String, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const loader = ref(false)
    const toast = useToast()
    const perobj = ref(null)
    const bajaAlumnoH = ref(null)
    const detalle = ref(null)
    const aCupdatefile = ref(false)
    const textareaResolucion = ref('')
    // files
    const checkProcess = ref({
      storagefile: false,
    })
    const fileToUpload = ref(null)
    const storedFiles = ref([])
    // Computed propieties
    const uploadconfig = computed(() => {
      const directorio = `alumnos/${perobj.value.id}/documentos/carta_recursamiento`
      const dataReturn = {
        ref: `/${directorio}`, cat: '9', repo: 0, struct: '3',
      }
      return dataReturn
    })
    const {
      detallePromise,
    } = useBajasDetalle(props.ag)
    const {
      alumnoBajaPromise,
    } = bajaAlumno(props.alubaja)
    const submitForm = () => {
      const datasent = {
        alumnos: [{
          id_persona: detalle.value.persona_fk,
          beca: null,
          status_actual: detalle.value.alu_status,
          d: null,
        }],
        becas: [],
      }
      store.dispatch('bajas/postDatosReinscribir', { data: datasent, periodo: perobj.value.id, plan: detalle.value.id_plan })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          vm.$swal({
            icon: 'success',
            allowOutsideClick: false,
            title: 'Orden de pago creada',
            html: 'Por favor gestione la orden de pago "Servicios Escolares"',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          emit('res', true)
        }, error => {
          vm.$swal({
            icon: 'error',
            allowOutsideClick: false,
            title: 'Lo sentimos - error de servicio',
            html: `${error}`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
    }
    const submitCSRForm = fid => {
      const datar = {
        ag: props.ag,
        mo: textareaResolucion.value,
        ar: fid.id,
      }
      store.dispatch('bajas/postDatosCrearSolR', { data: datar })
        .then(response => {
          if (response.status === 200) {
            fileToUpload.value = null
            submitForm()
          }
        }, error => {
          vm.$swal({
            icon: 'error',
            allowOutsideClick: false,
            title: 'Lo sentimos - error de servicio - no se creó la solicitud de recursamiento',
            html: `${error}`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
    }
    const uploadfile = () => {
      loader.value = true
      uploadconfig.value.file = fileToUpload.value
      if (uploadconfig.value.file.type === 'application/pdf') {
        store.dispatch('cuenta/handleFile', uploadconfig.value)
          .then(response => {
            const [dlvryResponse] = response.data.ids
            if (response.data.msg === 'OK') {
              assignAsPersonalDocument({
                task: 'wsdocumentos', action: 2, token: store.state.cuenta.session.token, p: detalle.value.persona_fk, f: dlvryResponse.id, td: 12,
              })
                .then(result => {
                  loader.value = false
                  if (result.status === 200) {
                    fileToUpload.value = null
                    submitCSRForm(dlvryResponse)
                  }
                }, error => {
                  loader.value = false
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Error al asignar documento',
                      text: error,
                      icon: 'AlertCircleIcon',
                      variant: 'danger',
                    },
                  },
                  { timeout: 5000 })
                })
            } else {
              loader.value = false
              toast({
                component: ToastificationContent,
                props: {
                  title: 'Seleccione el archivo nuevamente',
                  text: response.data.msg,
                  icon: response.icon,
                  variant: response.label,
                },
              },
              { timeout: 10000 })
            }
          }, error => {
            loader.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
      } else {
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Solo se aceptan archivos PDF',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 8000 })
      }
    }
    const validationForm = () => {
      emit('res', false)
      let mensaje = ''
      if (detalle.value !== null && bajaAlumnoH.value !== null && props.ag !== null) {
        if (perobj.value === null) mensaje += 'No se ha seleccionado ningun periodo.'
        else {
          if (perobj.value.id === detalle.value.id_periodo_baja) mensaje += ' Selecciona un periodo que no sea igual al periodo de baja. Si desea realizar esta operación contacte al área de sistemas.'
          if (bajaAlumnoH.value.historico_status_agenda === 7) {
            if (textareaResolucion.value.length < 10) mensaje += ' Completa el texto - Razón de la Resolución. min 10 Caracteres'
            if (fileToUpload.value === null) mensaje += ' Este alumno necesita una carta de recursamiento en formato pdf'
          }
        }
      } else mensaje += ' No podemos Reinscribir al alumno detalle [null], contacte al área de sistemas.'

      if (mensaje === '') {
        vm.$swal({
          icon: 'warning',
          allowOutsideClick: false,
          title: 'Re - Inscribir',
          html: 'Al dar click ya no se podrán hacer cambios sin intervención del área de sistemas',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
        }).then(result => {
          if (result.value) {
            if (bajaAlumnoH.value.historico_status_agenda === 7) uploadfile()
            else submitForm()
          }
        })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: mensaje,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 2000 })
      }
    }
    watch(() => bajaAlumnoH.value, valor => {
      if (valor.historico_status_agenda === 7) aCupdatefile.value = true
    })
    onMounted(() => {
      loader.value = true
      Promise.all([detallePromise, alumnoBajaPromise])
        .then(values => {
          const [[d], [h]] = values
          bajaAlumnoH.value = h
          detalle.value = d
          loader.value = false
        })
        .catch(error => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error del servicio',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    })
    return {
      bajaAlumnoH,
      loader,
      validationForm,
      perobj,
      storedFiles,
      fileToUpload,
      detalle,
      aCupdatefile,
      textareaResolucion,
      // archivo
      uploadfile,
      checkProcess,
    }
  },
}
</script>
<style lang="scss">
.custom-file-input:lang(es) ~ .custom-file-label::after {
  content: 'Buscar';
}
</style>
